import { useState, useCallback, useEffect } from 'react';

export const useApprovalLogic = (approvers, currentIndex) => {
  const [approvalData, setApprovalData] = useState([]);

  // Initialize approval data when approvers change
  useEffect(() => {
    if (approvers && approvers?.length > 0) {
      const initialData = approvers?.map(approver => ({
        id: approver?.id || '',
        Approvername: approver?.Approvername || '',
        ApproverRole: approver?.ApproverRole || '',
        status_btn: approver?.status_btn || '',
        comments: approver?.comments || '',
        Approved_flg: approver?.Approved_flg || false,
        status: approver?.status || false,
        time: approver?.time || '',
        OneTimeApproved_flg: approver?.OneTimeApproved_flg || false
      }));
      setApprovalData(initialData);
    }
  }, [approvers]);

  const handleApprovalChange = useCallback((field, value) => {
    setApprovalData(prev => {
      if (prev.length === 0 || currentIndex >= prev.length) {
        return prev;
      }
      
      const newData = [...prev];
      const current = { ...newData[currentIndex] };
      
      current[field] = value;
      
      // Update flags based on status_btn
      if (field === 'status_btn') {
        current.status = true;
        current.Approved_flg = value === 'yes';
        current.time = new Date().toJSON();
      }
      
      newData[currentIndex] = current;
      return newData;
    });
  }, [currentIndex]);

  return { 
    approvalData: approvalData[currentIndex] || {}, 
    handleApprovalChange,
    allApprovalData: approvalData
  };
};